import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { getMessages } from "../data/chat";


export default function useGetChatMessages (chat_id) {

    const dispatch = useDispatch()

    const setChatMessages = useCallback((messages) => {
        dispatch({type: 'SET_CHAT_MESSAGES', messages: messages});
    }, [dispatch])

    const getChatMessages = useCallback(() => {
        getMessages(chat_id)
            .then(response => {
                setChatMessages(response.data.messages)
                var div = document.getElementById("messagesBody");
                div.scrollTop = div.scrollHeight;
            }).catch(error => {
                console.error(error);
                if (error.response.status === 404) {
                    // delete selected conversation form list of chats
                    localStorage.removeItem('localStorage')
                    dispatch({ type: 'CLEAR_SELECTED_CONVERSATION_DATA'})
                }
            })
    }, [chat_id, dispatch, setChatMessages])

    return {
        getChatMessages
    }
}
